import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateTime } from 'luxon';
import { timeFormat } from '../../helpers/timeFormat';
import { environment } from '@environment';

@Component({
    selector: 'time-entry',
    templateUrl: './time-entry.component.html',
    styleUrls: ['./time-entry.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => TimeEntryComponent),
        }
    ]
})
export class TimeEntryComponent implements OnInit, ControlValueAccessor {

    @Input() value: string;
    @Output() input: EventEmitter<string> = new EventEmitter<string>();

    @Input() timezone: string = environment.fallbackTimeZone;
    @Input() isRequired: boolean = false;
    @Input() inputId: string;
    @Input() disabled: boolean;
    @Input() readonly: boolean;
    @Input() tabindex: boolean;
    @Input() name: string;
    @Input() displaySeconds: boolean = false;
    @Input() only24Hours: boolean = true;
    @Input() showButton: boolean = true;

    @Output() change: EventEmitter<string> = new EventEmitter<string>();

    onChange: ((val: string) => void)[] = [];
    onTouched: (() => void)[] = [];

    constructor() {
        this.registerOnChange((val: string) => this.input.emit(val));
        this.registerOnChange((val: string) => this.change.emit(val));
    }

    ngOnInit(): void {
    }

    setCurrentTime(): void {
        this.value = DateTime.local()
            .setZone(this.timezone ?? environment.fallbackTimeZone)
            .toLocaleString(this.displaySeconds ? DateTime.TIME_24_WITH_SECONDS : DateTime.TIME_24_SIMPLE);
        this.onChangeTime();
    }

    onChangeTime(): void {
        const formattedTime = this.value ? timeFormat(this.value, this.displaySeconds, this.only24Hours) : null;
        this.value = formattedTime;
        this.onChange.forEach(f => f(formattedTime));
    }

    Focused(): void {
        this.onTouched.forEach(f => f());
    }

    registerOnChange(fn: any): void {
        this.onChange.push(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched.push(fn);
    }

    writeValue(val: any): void {
        const str = val?.toString() ?? '';

        if (str)
            this.value = timeFormat(str, this.displaySeconds, this.only24Hours);
        else
            this.value = null;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
